import { writable } from 'svelte/store';
import OnUnsavedChanges from './components/Modals/OnUnsavedChanges.svelte';

/**
 * @typedef {Object} BreacrumbsInterface
 * @property {string[]} items
 * @property {Object<string, string>} custom_paths
 * @property {boolean} go_back
 * @property {string} default_home
 */
let BreacrumbsInterface;


let RouterStoreType = {
    parameters: {},
    props: {},
    action_name: null,
    role: null,
    controller_name: null,
    has_footer: false,
    has_sidebar: false,
    has_header: false,
    has_navbar_mobile: false,        
    has_space_fixed_to_top: false,
    classes: "",
    Footer: null,
    subtemplate: null,
    BoxHeader: null,
    user: null,
    styles_box: null,
    /**
     * @type {BreacrumbsInterface}
     */
    breadcrumbs: {},
    setGridStylesAuto: ()=>{},
    updateGridStyles: ()=>{},
    updateHeaderComponent: ()=>{},
    updateSidebarComponent: ()=>{},
    updateNavBarMobileComponent: ()=>{},
    updateBoxHeaderComponent: ()=>{},
    updateFooterComponent: ()=>{},
    updateHasHeader: ()=>{},
    updateHasFooter: ()=>{},
    updateHasSidebar: ()=>{},
    updateHasNavbarMobile: ()=>{},
    updateHasSpaceFixedToTop: ()=>{},
    updateProperties: (properties)=>{}
};

function routerStore() {
    /**
     * @type {RouterStoreType}
     */
    let defaultElement = RouterStoreType;
	const { subscribe, update } = writable(defaultElement);
	
	const routes = {
        subscribe: subscribe,
        set: (field, new_data)=>{
            update(( data )=>{
                data[field] = new_data;
                return data;
            })
        },
        updateField: (field, new_data)=>{
            let object = {};
            update(( data )=>{
                data[field] = new_data;
                object = data;
                return data;
            })

            return object;
        },        
        update: (new_data)=>{
            update(( data )=>{
                Object.values(new_data).map((item, key)=>{
                    let name = Object.keys(new_data)[key];

                    data[name] = item;
                })
                
                return data;
            })

            return new_data;
        },
        updateBreadcrumbs(properties){
            update(( data )=>{
                data.breadcrumbs = properties
                return data;
            })

            return properties;
        },
        /**
         * @returns {RouterStoreType}
         */
        get: function(){
            let returns = {};
            update(function( data ){
                returns = data;
                return data;
            })
            return returns;
        }
    }
    return routes;
}




const RouterStore = routerStore();
export {RouterStore, RouterStoreType, BreacrumbsInterface}